export default __webpack_public_path__ + "static/central-otago-marlborough-map-1b959f3eea8a3bde690c4868e4b91c5d.svg";